import Loadable from '../../components/loadable';

const ExportModal = Loadable({
  loader: () => import('../../components/export_modal'),
  type: 'modal',
});

angular.module('shared').value('ExportModal', ExportModal);
